/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdatePromosDto { 
    /**
     * Code of promo (e.g., VIP001) and maximum 12 characters
     */
    code?: string;
    /**
     * Type of promo (e.g., percent / amount)
     */
    type?: string;
    /**
     * Discount value (e.g., 10)
     */
    value?: number;
    /**
     * Usage limit (e.g., 10)
     */
    usageLimit?: number;
    /**
     * Expiration date (ISO format)
     */
    expirationDate?: string;
    /**
     * Is the promo active?
     */
    isActive?: boolean;
    /**
     * Created by organizer ID
     */
    createdById?: string;
}

